import React, { useState, useEffect, useRef ,useMemo } from "react";
import he from "he";
import { useNavigate } from "react-router-dom";
import "./JobListing.css";
import { useSelector } from "react-redux";
import { fixImagePaths } from "../util";

const JobListing = () => {
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const searchRef = useRef(null); // Reference for the search container
  const navigate = useNavigate();
  const { jobs} = useSelector((state) => state.data);
  const [talentPoolBar, setTalentPoolBar] = useState("");
  const { page } = useSelector((state) => state.data);
  
  useEffect(() => {
      if (page?.statusCode === 200 && page?.data?.talent_pool_bar) {
          setTalentPoolBar(he.decode(page.data.talent_pool_bar.htmlContent));
        }
  }, [page]);

  const processedContent = useMemo(() => fixImagePaths(talentPoolBar), [talentPoolBar]);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredJobs([]);
      setShowDropdown(false);
    } else {
      const matches = jobs.filter(job =>
        job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        job.location.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredJobs(matches);
      setShowDropdown(matches.length > 0);
    }
  }, [searchTerm, jobs]);

  const handleSelectJob = (job) => {
    setSearchTerm(job.title);
    setShowDropdown(false);
    navigate(`/job-description/${job._id}`);
  };

  // Handle clicking outside the search container
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const sectionStyle = {
    // position: "relative",
    // width: "100%",
    // height: "300px",
    // backgroundSize: "cover",
    // backgroundPosition: "center top",
    // display: "flex",
    // justifyContent: "left",
    // alignItems: "center",
    // textAlign: "left",
  };

  const displayedJobs = showMore ? jobs : jobs.slice(0, 4);
  const columnsPerRow = 3;
  const totalDisplayed = displayedJobs.length;
  const emptySlots = (columnsPerRow - (totalDisplayed % columnsPerRow)) % columnsPerRow;


  return (
    <div className="back-img">
      <div className="job-listing-section">
        <div className="main-job-container">
          <div className="job-title-container">
            <h2>
              <span>Current Vacancies</span>
            </h2>
          </div>

          {/* 🔍 Search Bar Container */}
          <div className="search-container" ref={searchRef}>
            <div className="search-bar">
              <input
                type="text"
                placeholder="Enter job title, keyword or location"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onFocus={() => setShowDropdown(true)}
              />
              <button>Search</button>
            </div>

            {/* Dropdown for search results */}
            {showDropdown && (
              <ul className="dropdown">
                {filteredJobs.map((job) => (
                  <li key={job._id} onClick={() => handleSelectJob(job)}>
                    {job.title} - {job.location}
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="job-listing-container">
            {displayedJobs.length > 0 ? (
              displayedJobs.map((job, index) => (
                <div key={index} className="job-listing-card">
                  <h3>{job.title}</h3>
                  <p dangerouslySetInnerHTML={{ __html: job.description }}></p>
                  <p>
                    <strong>Location:</strong> {job.location}
                  </p>
                  <p>
                    <strong>Posted on: </strong>{new Date(job.createdAt).toLocaleDateString('en-GB')}

                  </p>
                  <button className="job-apply-btn" onClick={() => navigate(`/job-description/${job._id}`)}>
                    View
                  </button>
                </div>
              ))
            ) : (
              <p>No active jobs available</p>
            )}

            {/* {emptySlots > 0 && (
              <div className="cover-up-card">
                <h3>Currently, we have {totalDisplayed} jobs available.</h3>
                <p>Check back later for new openings.</p>
              </div>
            )} */}
          </div>

          {jobs.length > 3 && (
            <button onClick={() => setShowMore(!showMore)} className="toggle-job-btn">
              {showMore ? "Show Less" : "Show More"}
            </button>
          )}
        </div>
      </div>

      <div>
        {processedContent && (
          <div className="whyWorkWithAkinex" dangerouslySetInnerHTML={{ __html: processedContent }} />
        )}
      </div>
    </div>
  );
};

export default JobListing;